import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ targetDate, onStop }) => {
  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };

      timeLeft.minutes = timeLeft.minutes < 10 ? '0' + timeLeft.minutes : timeLeft.minutes;
      timeLeft.seconds = timeLeft.seconds < 10 ? '0' + timeLeft.seconds : timeLeft.seconds;
    } else {
      if (onStop)
        onStop();
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    // Clear timeout if the component is unmounted or targetDate changes
    return () => clearTimeout(timer);
  });

  //const timerComponents = [];

  // Object.keys(timeLeft).forEach(interval => {
  //   if (!timeLeft[interval]) {
  //     return;
  //   }

  //   timerComponents.push(
  //     <span key={interval}>
  //       {timeLeft[interval]} {interval}{' '}
  //     </span>
  //   );
  // });

  return (
    <>
      {Object.keys(timeLeft).length > 0 ? <span>{timeLeft.minutes + ':' + timeLeft.seconds}</span> : <></>}
    </>
  );
};

export default CountdownTimer;
